module.exports = __webpack_public_path__ + "img/hymnal.bd682ab1.jpg";